import React, { useEffect, useState } from "react";
import { Field, reduxForm, change } from "redux-form";
import { required } from "redux-form-validators";
import { connect, useDispatch, useSelector } from "react-redux";
import { renderField, renderselapi, renderselect } from "../../../../Components/Forms/renders";
import { fechgastenprofiel } from "../../Reducers/actions";

// Taal opties voor de dropdown (object formaat voor renderselect)
const taalOpties = {
  'nl': '🇳🇱 Nederlands',
  'de': '🇩🇪 Deutsch',
  'fr': '🇫🇷 Français',
  'en': '🇬🇧 English'
};

const EditGastForm = ({ handleSubmit, emailadres, dispatch, bedrijf, loading: submitLoading }) => {
  const [loading, setLoading] = useState(true);
  const reduxDispatch = useDispatch();

  // Stel het e-mailadres en standaard taal in bij het laden van het formulier
  useEffect(() => {
    dispatch(change("insertgastenGasten", "email", emailadres));
    dispatch(change("insertgastenGasten", "taal", "nl")); // Nederlands als standaard
  }, [dispatch, emailadres]);

  // Ophalen van gastenprofielen
  const gastenprofielen = useSelector((state) => state.gastenverbruik.gastenprofielen || []);

  useEffect(() => {
    reduxDispatch(fechgastenprofiel())
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  }, [reduxDispatch]);

  return (
    <div>
      {!loading ? (
        <form onSubmit={handleSubmit}>
          <div className="box-body">
            <div className="row">
              <div className="col-12">
                <Field name="email" type="email" component={renderField} label="E-mail" validate={required({ msg: "Dit item is verplicht" })} />
                <Field name="gastenid" type="input" component={renderField} label="Gasten Id" />
                {bedrijf?.soort === "jachthaven" && <Field name="bootnaam" type="text" label="Bootnaam" component={renderField} />}
                <Field name="voornaam" type="text" label="Voornaam" component={renderField} />
                <Field name="tussennaam" type="text" label="Tussenvoegsel" component={renderField} />
                <Field name="achternaam" type="text" label="Achternaam" component={renderField} />
                <Field name="taal" label="Taal" options={taalOpties} component={renderselect} validate={required({ msg: "Dit item is verplicht" })} />
                <Field name="gastenprofiel" type="input" label="Gastprofiel" options={gastenprofielen} inputnaam="naam" inputvalue="_id" component={renderselapi} validate={required({ msg: "Dit item is verplicht" })} />
              </div>
            </div>
          </div>
          <div className="pull-left submit">
            <button
              type="submit"
              className="btn btn-next btn-fill btn-success btn-wd btn-mg"
              disabled={submitLoading}
            >
              {submitLoading ? (
                <>
                  <i className="fa fa-spinner fa-spin"></i> Bezig met opslaan...
                </>
              ) : (
                'Opslaan'
              )}
            </button>
          </div>
        </form>
      ) : (
        <div>Loading...</div>
      )}
    </div>
  );
};

export default reduxForm({
  form: "insertgastenGasten",
})(EditGastForm);
